import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input, Modal, Stepper } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Checkout.css";
import Policy from "./Policy";
import moment from "moment";
import ReviewOrder from "./ReviewOrder";
import Shipping from "./Shipping";
import _ from "lodash";
import { createB2BAPI } from "../../../api/Interceptor";
import B2BButton from "../../common/B2BButton";
import { FaInfoCircle } from "react-icons/fa";
import IdentityVerificationModal from "./IdentityVerificationModal";
import notify from "../../../utils/Notification";

export default function Checkout({ reloadHeader, headerKey }) {
  const [activeStep, setActiveStep] = useState(0);
  const [selectedAddresses, setSelectedAddresses] = useState({
    billLocation: null,
    shipLocation: null,
  });
  const [payment, setPayment] = useState("bank-transfer");
  const location = useLocation();
  const navigate = useNavigate();
  const [uom] = useState(location?.state?.uom)
  const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);
  const [values, setValues] = useState(null)
  const [modalOpenAadhaar, setModalOpenAadhaar] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [aadhaar, setAadhaar] = useState("");
  const [otp, setOtp] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  let valueOption = ["PICKUP", "FREIGHT FORWARD"];

  const [delivery, setDelivery] = useState("");
  const [cartData] = useState(() =>
    Array.isArray(location?.state?.cartItem) ? location?.state?.cartItem : []
  );

  const [priceSlab] = useState(location?.state?.priceSlab);
  const [wholesaleSelected] = useState(location?.state?.wholesaleSelected);
  console.log("fro checklout")
  console.log(cartData, "fro checklout")
  const [combo] = useState(location?.state?.comboSelected);
  const [isLoading, setIsLoading] = useState(false);
  const [amount] = useState(location?.state?.amount);
  const [profile, setProfile] = useState(null);
  const [loyalty, setLoyalty] = useState(null);
  const [walletChecked, setWalletChecked] = useState(false);
  const [cartInfo, setCartInfo] = useState({
    subTotal: 0,
    total: 0.0,
  });
  const [openMtoModal, setOpenMtoModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addedWallet, setAddedWallet] = useState(0);
  const [customerId, setCustomerId] = useState("");
  const [shippingCost, setShippingCost] = useState(0);
  const [paackingCharge, setPackingCharge] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 5 });
  const sampleCharge = paackingCharge.find(
    (p) => p.name?.toUpperCase() === "SAMPLE"
  );
  const swatchCharge = paackingCharge.find(
    (p) => p.name?.toUpperCase() === "SWATCH"
  );
  const wholesaleCharge = paackingCharge.find(
    (p) => p.name?.toUpperCase() === "WHOLESALE"
  );

  const foundItem = cartData?.find((item) => item?.cartType);
  const cartType = foundItem?.cartType === "COMBO" ? "WHOLESALE" : foundItem?.cartType || "WHOLESALE";

  const rates = {
    SAMPLE: sampleCharge?.amount || 0,
    SWATCH: swatchCharge?.amount || 0,
    WHOLESALE: wholesaleCharge?.amount || 0,
  };

  const ratesExtra = {
    SAMPLE: sampleCharge?.priceAddition || 0,
    SWATCH: swatchCharge?.priceAddition || 0,
    WHOLESALE: wholesaleCharge?.priceAddition || 0,
  };
  const packingChargeValue = rates[cartType];
  const extraPackingChargePer2Roll = ratesExtra[cartType]
  useEffect(() => {
    featchProfile();
  }, []);
  const getRedirectPath = (cartData) => {
    if (!Array.isArray(cartData) || cartData.length === 0) {
      return "/place-Orders";
    }

    const type = (cartData[0]?.cartType || "").toUpperCase();

    switch (type) {
      case "SAMPLE":
        return "/place-Sample";
      case "SWATCH":
        return "/place-Swatch";
      case "WHOLESALE":
      default:
        return "/place-Orders";
    }
  };
  useEffect(() => {
    if (!Array.isArray(cartData) || cartData.length === 0) {
      return;
    }

    const subTotal = cartData.length;
    const total = cartData.reduce((sum, item) => {
      const cartType = (item.cartType || "").toUpperCase();
      let itemTotal = 0;

      if (
        cartType === "SAMPLE" ||
        cartType === "SWATCH" ||
        cartType === "WHOLESALE"
      ) {
        // simple per-unit pricing
        itemTotal = (item.sellingPrice || 0) * (item.quantity || 1);
      } else if (combo && item.combo) {
        // const discount = priceSlab[item.pimVariantId]?.discount || 0;
        const price = (item.combo.sellingPrice || 0);
        itemTotal =
          price * (item.combo.quantity || 1) * (item.variants?.length || 1);
      } else if (!combo) {

        const price = (item.sellingPrice || 0);
        itemTotal = price * (item.quantity || 1);
      }

      return sum + itemTotal;
    }, 0);

    setCartInfo({
      subTotal,
      total: total.toFixed(2),
    });

    getAllPacking();
  }, [cartData, combo, priceSlab]);

  useEffect(() => {
    calculateShippingCharge();
    getAllPacking();
  }, [pagination.pageIndex, pagination.pageSize]);

  const isMobile = useMediaQuery("(max-width: 767px)");



  const isFullOrderDriven = useMemo(() => {
    if (!Array.isArray(cartData) || cartData.length === 0) return false;

    return cartData.every(
      (item) => (item.typeOfSupply || "").toUpperCase() === "ORDERDRIVEN"
    );
  }, [cartData]);

  const shouldShowMtoPopup = useMemo(() => {
    if (!Array.isArray(cartData) || cartData.length === 0) return false;

    return cartData.some(
      (item) => (item.typeOfSupply || "").toUpperCase() === "ORDERDRIVEN"
    );
  }, [cartData]);

  const handleOk = () => {
    setOpenMtoModal(false);

    navigate(
      isFullOrderDriven
        ? "/mtoInguiry"
        : getRedirectPath(cartData)
    );
  };
  const getAllPacking = async () => {
    try {
      const res = await B2B_API.get(
        `shipmenttype/view?page=${pagination.pageIndex}&pageSize=${pagination.pageSize}`
      ).json();
      setPackingCharge(res?.response?.content);
    } catch (e) {
      console.log("Fail to fetch Packing", e);
    }
  };
  const calculateShippingCharge = () => {
    const shippingCost =
      selectedAddresses?.shipLocation?.transporterCharges?.charges || 0;

    const totalQty = cartData.reduce((sum, item) => {
      if (item.combo) {
        return sum + item.combo.quantity * (item.variants?.length || 0);
      }

      if (item.cartType === "WHOLESALE") {
        return sum + (item.quantity || 0);
      }

      if (item.cartType === "SAMPLE" || item.cartType === "SWATCH") {
        return sum + (item.quantity || 0);
      }

      return sum + (item.quantity || 0);
    }, 0);

    const charge = shippingCost * totalQty;
    return charge.toFixed(2);
  };
  const handleAdhaarVerification = async () => {
    setModalOpenAadhaar(true);
    setAadhaarStep(1);
    setAadhaar("");
    setOtp("");
    setAadhaarError("");
    setIsAadhaarVerified(false);
  }

  const handleAadhaarChange = (e) => {
    let value = e.target.value.replace(/\D/g, '').slice(0, 12);
    if (value.length > 8) {
      value = `${value.slice(0, 4)} ${value.slice(4, 8)} ${value.slice(8)}`;
    } else if (value.length > 4) {
      value = `${value.slice(0, 4)} ${value.slice(4)}`;
    }
    setAadhaar(value);
  };

  const handleSendOtp = async () => {
    setAadhaarLoading(true);
    setAadhaarError("");
    try {
      const cleanAadhaar = aadhaar.replace(/\s/g, '');
      const response = await B2B_API.post("aadhaar/send-otp", {
        json: {
          aadhaarNumber: cleanAadhaar,
          consent: "Y",
        },
      }).json();


      if (response?.data?.success) {
        setTransactionId(response.data.txnId);
        setAadhaarStep(2);
        setAadhaarError("");
      } else {
        setAadhaarError(response?.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error("Error sending Aadhaar OTP:", error);
      setAadhaarError("Network or server error. Please try again.");
    } finally {
      setAadhaarLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    setAadhaarLoading(true);
    setAadhaarError("");
    try {
      const cleanAadhaar = aadhaar.replace(/\s/g, '');
      const response = await B2B_API.post("aadhaar/verify", {
        json: {
          aadhaarNumber: cleanAadhaar,
          otp,
          transactionId,
        },
      }).json();

      if (response?.status === "SUCCESS") {
        setIsAadhaarVerified(true);
        setAadhaarError("");
        setTimeout(() => {
          setModalOpenAadhaar(false);
          handlePlaceOrder();
        }, 2000);
      } else {
        setAadhaarError(response?.message || "OTP verification failed");
      }
    } catch (error) {
      setAadhaarError("Verification failed. Please try again.");
    } finally {
      setAadhaarLoading(false);
    }
  };


  const handleResendOtp = () => {
    setOtp("");
    setAadhaarError("");
    handleSendOtp();
  };

  const handlePlaceOrder = async (p = false) => {
    setIsPlacingOrder(true);
    const safeItems = cartData?.filter(
      (item) =>
        (item.combo && Array.isArray(item.variants)) ||
        typeof item.quantity === "number"
    );

    const orderLines = safeItems?.map((item) => {
      let qty = 0;
      if (item.combo) {
        qty = (item.combo.quantity || 0) * (item.variants?.length || 0);
      } else if (item.cartType === "SWATCH") {
        qty = (item.quantity || 0) * 0.5;
      } else {
        qty = item.quantity || 0;
      }



      const basePrice = item.combo
        ? item.combo.sellingPrice
        : item.sellingPrice;
      const unitPrice = basePrice;

      return {
        pimVariantId: item.pimVariantId || item.combo?.pimVariantId || "",
        kg: qty,
        totalAmount: unitPrice * qty,
      };
    });

    const grossTotal = orderLines.reduce(
      (sum, line) => sum + (line.totalAmount || 0),
      0
    );

    const payloadItems = safeItems.map((item) =>
      item.combo
        ? item.combo
          ? (() => {
            const combo = { ...item.combo }; // avoid mutating original
            combo.ribItems = item?.variants?.map((variant) => variant?.ribItem);
            if (combo?.ribItems?.length === 0) {
              combo.ribItems = null
            }
            return combo;
          })()
          : null

        : (() => {

          return {
            ...item,
            ribItems: item.ribItem ? [item.ribItem] : null,
          };
        })()

    );
    const shipCost = parseFloat(calculateShippingCharge()) || 0;
    const order = {
      billLocation: selectedAddresses.billLocation,
      shipLocation: selectedAddresses.shipLocation,
      paymentMode: payment,
      deliveryMode: delivery,
      swatchPoint: walletChecked ? addedWallet : 0,
      shipmentCost: shipCost,
      grossTotal,
      items: payloadItems,
      permissionGranted: p,
    };
    try {
      await B2B_API.post("order/save", { json: order }).json();
      notify({
        error: false,
        success: true,
        title: "Order Placed Successfully",
      });
      if (shouldShowMtoPopup) {
        setOpenMtoModal(true);
      } else {
        navigate(getRedirectPath(cartData));
      }
      reloadHeader();

    } catch (error) {
      console.log("error", error)
      if (error?.value) {
        setErrorModal(true); setValues(error?.skus)
      }
      notify({
        error: true,
        success: false,
        title: error?.message || "Something went wrong",
      });
    } finally {
      setIsPlacingOrder(false);
    }
  };
  const handleWalletCheckChange = () => {
    setWalletChecked((prev) => !prev);
  };
  const handleNextStep = () => {
    setActiveStep((current) => (current < 2 ? current + 1 : current));
    setShippingCost(parseFloat(calculateShippingCharge()));
  };

  const featchProfile = async () => {
    try {
      setLoading(true);
      const res = await B2B_API.get("customer/profile").json();
      await fetchLoyalty(res?.response?.loyaltyId)
      setCustomerId(res?.response?.customerId);
      setProfile(res.response);
    } catch (error) {
      console.error("Error fetching recommended items:", error);
    } finally {
      setLoading(false);
    }
  }

  const fetchLoyalty = async (loyaltyId) => {
    try {
      setLoading(true);
      if (!loyaltyId) {
        return
      }
      const res = await B2B_API.get(`loyalty/loyaltyId?loyaltyId=${loyaltyId}`).json();
      setLoyalty(res.response);
    } catch (error) {
      console.error("Error fetching recommended items:", error);
    } finally {
      setLoading(false);
    }
  }
  const permissionGrantedd = useMemo(() => {
    if (!Array.isArray(cartData) || cartData.length === 0) return false;

    // true only if ALL are ORDERDRIVEN
    return cartData.every(
      (item) => (item.typeOfSupply || "").toUpperCase() === "ORDERDRIVEN"
    );
  }, [cartData]);
  const stepsData = [
    {
      label: "Shipping",
      description: "",
      component: (
        <Shipping
          setDelivery={setDelivery}
          delivery={delivery}
          valueOption={valueOption}
          cartInfo={cartInfo}
          profile={profile}
          loyalty={loyalty}
          cartData={cartData}
          selectedAddresses={selectedAddresses}
          setSelectedAddresses={setSelectedAddresses}
          activeStep={0}
          handleNextStep={() => handleNextStep()}
          price={priceSlab}
          combo={combo}
          uom={uom}
        />
      ),
    },
    {
      label: "Policy",
      description: "",
      component: (
        <Policy
          cartInfo={cartInfo}
          cartData={cartData}
          profile={profile}
          loyalty={loyalty}
          priceSlab={priceSlab}
          activeStep={1}
          handleNextStep={() => handleNextStep()}
          combo={combo}
          uom={uom}
        />
      ),
    },
    {
      label: "Review Order",
      description: "",
      component: (
        <ReviewOrder
          payment={payment}
          delivery={delivery}
          setPayment={setPayment}
          setModalOpen={setModalOpen}
          cartInfo={cartInfo}
          cartData={cartData}
          priceSlab={priceSlab}
          profile={profile}
          loyalty={loyalty}
          handlePlaceOrder={handlePlaceOrder}
          selectedAddresses={selectedAddresses}
          isLoading={isLoading}
          isPlacingOrder={isPlacingOrder}
          activeStep={2}
          handleNextStep={() => handleNextStep()}
          combo={combo}
          calculateShippingCharge={calculateShippingCharge()}
          valueOption={valueOption}
          walletChecked={walletChecked}
          amount={amount}
          handleWalletCheck={handleWalletCheckChange}
          setAddedWallet={setAddedWallet}
          packingCharge={packingChargeValue}
          uom={uom}
          extraPackingChargePer2Roll={extraPackingChargePer2Roll}
        />
      ),
    },
  ];
  const getIconForStep = (stepIndex) => {
    if (stepIndex <= activeStep) {
      return <FontAwesomeIcon icon={faCheck} />;
    }
    return <FontAwesomeIcon icon={faCheck} color="#d1d5db" />;
  };

  const handleStepClick = (stepIndex) => {
    if (stepIndex <= activeStep) {
      setActiveStep(stepIndex);
    }
  };

  return (
    <div className="view-checkout router-view-container">
      <Stepper
        onStepClick={handleStepClick}
        color="#8BC53F"
        styles={{
          steps: !isMobile && {
            height: "6rem",
            margin: "auto",
            background: "#fff",
            borderRadius: "15px",
            paddingInline: "2rem",
          },
          step: isMobile
            ? { flexDirection: "column" }
            : { paddingInline: "2rem" },
        }}
        active={activeStep}
        size="sm"
        iconSize={24}
        completedIcon={<FontAwesomeIcon icon={faCheck} />}
      >
        {stepsData.map((step, index) => (
          <Stepper.Step
            key={index}
            label={step.label}
            description={step.description}
            icon={getIconForStep(index)}
            styles={{
              stepIcon: {
                backgroundColor: "white",
                borderColor: "#8BC53F",
                border: "1px #8BC53F solid",
              }

            }}
            progressIcon={<FontAwesomeIcon icon={faCheck} />}
          >
            {activeStep === index && step.component}
          </Stepper.Step>
        ))}
      </Stepper>
      <Modal
        opened={errorModal}
        onClose={() => setErrorModal(false)}
        centered
        title={
          <span style={{
            fontSize: "20px",
            fontWeight: "700",
            color: "#d32f2f"
          }}>
            Stock Not Available
          </span>}

      >

        <div style={{
          fontSize: 15,
          lineHeight: "22px",
          color: "#444",
        }}>
          Some variants
          {values?.length > 0 && (
            <strong style={{ color: "#000" }}>
              {" "}({values.map(v => v).join(", ")})
            </strong>
          )}
          {" "}in your cart are out of stock.
          Would you like to proceed with the remaining items?
        </div>

        <div style={{
          display: "flex",
          gap: "12px",
          justifyContent: "flex-end"
        }}>
          <B2BButton
            name="Cancel"
            style={{
              backgroundColor: "#e53935",
              color: "white",
              padding: "8px 16px",
              borderRadius: 6,
              fontWeight: "600",
              minWidth: 100
            }}
            onClick={() => setErrorModal(false)}
          />

          <B2BButton
            name="Proceed"
            style={{
              backgroundColor: "#8BC53F",
              color: "white",
              padding: "8px 16px",
              borderRadius: 6,
              fontWeight: "600",
              minWidth: 100
            }}
            onClick={() => {
              setErrorModal(false);
              handlePlaceOrder(true);
            }}
          />
        </div>
      </Modal>
      <Modal
        opened={openMtoModal}
        onClose={() => { }}
        closeOnClickOutside={false}
        closeOnEscape={false}
        withCloseButton={false}
        centered
        size="sm"
      >
        <div>
          <div
            style={{
              color: "red",
              fontSize: 14,
              fontWeight: 900,
              marginBottom: 10,
            }}
          >
            {cartData
              ?.filter((i) => (i.typeOfSupply || "").toUpperCase() === "ORDERDRIVEN")
              ?.map((i) => i.variantName)
              .join(" , ")}
          </div>

          <p style={{ fontSize: 14 }}>
            This is an Made To Order. Account Manager will call you once this converts into a sales order.
          </p>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 12 }}>
            <Button
              color="#8BC53F"
              onClick={handleOk}
            >
              OK
            </Button>
          </div>
        </div>
      </Modal>
      <IdentityVerificationModal
        opened={modalOpen}
        handlePlaceOrder={handlePlaceOrder}
        setModalOpen={setModalOpen}
      />
    </div>
  );
}
